import * as types from '../constants/ActionTypes'


const filtersReducerDefaultState = {
    products:[],
    numOfProducts:0,

    brand: {
        data: [],
        loading: false,
        error: null
    },
    colour: {
        data: [],
        loading: false,
        error: null
    },
    size: {
        data: [],
        loading: false,
        error: null
    },
    gender: {
        data: [],
        loading: false,
        error: null
    },
    range: {
        data: [],
        loading: false,
        error: null
    },
    categories: {
        data: [],
        loading: false,
        error: null
    },
    searchSelectedFilters : {},
    sortBy: "",
    loading: false,
    errror: null
};

const filtersReducer = (state = filtersReducerDefaultState, action) => {
    // 
    
    switch (action.type) {
        case types.SEARCH_FILTER_ALL_SUCCESS:
            return {
                ...state,
                brand: { data: action.allFilters.brand_list },
                gender: { data: action.allFilters.gender_list },
                size: { data: action.allFilters.size_list },
                colour: { data: action.allFilters.color_list },
                range: { data: action.allFilters.price_range },
                categories: { data: action.allFilters.category_list },
                numOfProducts: 'undefined',
                loading: false,
            };
        case types.SEARCH_FILTER_ALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case types.SEARCH_FILTER_ALL_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
            //search product
            case types.PRODUCT_SEARCH_FILTER_ALL_SUCCESS:
                return {
                    ...state,
                    products: action.allFilters.products ,
                    numOfProducts : action.allFilters.total_count,                
                    loading: false,
                };
            case types.PRODUCT_SEARCH_FILTER_ALL_REQUEST:
                return {
                    ...state,
                    loading: true
                };
            case types.PRODUCT_SEARCH_FILTER_ALL_FAILURE:
                return {
                    ...state,
                    loading: false,
                    error: action.error
                };

                

        case types.SEARCH_FILTER_SET:
            return {
                ...state,
                searchSelectedFilters: {...action.selected }
            };
        case types.SEARCH_FILTER_BRAND_SUCCESS:
            return {
                ...state,
                brand: {
                    data: action.brands,
                    loading: false
                },
            };
        case types.SEARCH_FILTER_BRAND_REQUEST:
            return {
                ...state,
                brand: { loading: true }
            };
        case types.SEARCH_FILTER_BRAND_FAILURE:
            return {
                ...state,
                colour: { loading: false, error: action.error }
            };
        case types.SEARCH_FILTER_COLOUR_SUCCESS:
            return {
                ...state,
                colour: { data: action.colours, loading: false }
            };
        case types.SEARCH_FILTER_COLOUR_REQUEST:
            return {
                ...state,
                colour: { loading: true }
            };
        case types.SEARCH_FILTER_COLOUR_FAILURE:
            return {
                ...state,
                brand: { loading: false, error: action.error }
            };
        case types.SEARCH_FILTER_GENDER_SUCCESS:
            return {
                ...state,
                gender: { data: action.genders, loading: false }
            };
        case types.SEARCH_FILTER_GENDER_REQUEST:
            return {
                ...state,
                gender: { loading: true }
            };
        case types.SEARCH_FILTER_GENDER_FAILURE:
            return {
                ...state,
                gender: { loading: false, error: action.error }
            };

        case types.SEARCH_FILTER_RANGE_SUCCESS:
            return {
                ...state,
                range: { data: action.range, loading: false }
            };
        case types.SEARCH_FILTER_RANGE_REQUEST:
            return {
                ...state,
                range: { loading: true }
            };
        case types.SEARCH_FILTER_RANGE_FAILURE:
            return {
                ...state,
                range: { loading: false, error: action.error }
            };

        case types.SEARCH_FILTER_COLOR:
            return {
                ...state,
                color: action.color
            };
        case types.SEARCH_FILTER_PRICE:
            return {
                ...state,
                value: { min: action.value.value.min, max: action.value.value.max }
            };
        case types.SORT_BY:
            return {
                ...state,
                sortBy: action.sort_by
            };
        case types.SEARCH_FILTER_RESET_SUCCESS:
            return {
                ...state,
                brand: {
                    data: []
                },
                gender: {
                    data: []
                },
                range: {
                    data: []
                },
                colour: {
                    data: []
                }
            };
        default:
            return state;
    }
}

export default filtersReducer;